import { intervalStrMap, State } from "../state/state";

/**
 * @brief
 *
 * @return A timer object initialized with empty or default values
 */
export const emptyTimer = (): State.Timer => ({
  label: "Timer Label",
  startDate: new Date().toISOString().split("T")[0],
  startTime: "00:00",
  interval: intervals()[0],
  cmds: {
    "/ATX/hardware/flags/mask": ["x", "x", "x", "x", "x", "x", "x", "x"]
  }
});

/**
 * @brief
 *
 * @return
 */
export const intervals = (): [State.INTERVALS_STR] =>
  Object.keys(intervalStrMap) as [State.INTERVALS_STR];
